export const BASE_IMG_URL = `https://yulin365.net/attachment/mini-icon/`;

// 活动类型
export const ACTIVITY_TYPE = {
	'video': 2, // 视频
	'audio':1, // 音频
	'text':3, // 文本
	'image': 4, // 图片
	'clock': 5, // 打卡类
	'riddles':6, // 灯谜
	'vote':7, // 投票
	'topic': 8, // 问答
	'video_audio': 10, // 视频+音频
	'works_clock': 11, // 作品打卡
	'submit': 13, // 作品打卡,
	
}

export const ACTIVITY_STATUS = {
	'not_start':2,
	'underway': 3,
	'end': 4
}


/** 字段类型 */
export const FIELD_TYPE = {
  // text: 0, //单行文本
  // select: 1, // 选择框
  // file: 2, // 文件上传
  // textarea: 3, // 多行文本
  text: "text", //单行文本
  select: "select", // 选择框
  file: "file", // 文件上传
  textarea: "textarea", // 多行文本
};

// 模块类型
export const MODULE_TYPE = {
	deep_read: 1,
	informed: 2,
	video_lectur: 3,
	qq_listen:4,
	qq_write: 5,
}



// WEBPACK FOOTER //
// ./src/constant/index.js